import ActivityModal from './main.activity'

export default ActivityModal